(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 87794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(76635);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34841);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_3__);




/**
 * It's a function that takes in a bunch of props and returns a bunch of meta tags.
 * @param  - FC<SeoProps> = ({
 * @returns A React component.
 */ var Seo = function(param) {
    var description = param.description, title = param.title, image = param.image, pagePath = param.pagePath, canonical = param.canonical, noIndex = param.noIndex, noFollow = param.noFollow, components = param.components;
    var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_3___default()().publicRuntimeConfig;
    var nextPublicBaseUrl = publicRuntimeConfig.nextPublicBaseUrl;
    var handleCanonicalUrl = function(url) {
        return url.split(/[?#]/)[0];
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: handleCanonicalUrl(canonical || pagePath === "/" ? "" : "".concat(nextPublicBaseUrl).concat(pagePath))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                href: handleCanonicalUrl("".concat(nextPublicBaseUrl, "en").concat(pagePath === null || pagePath === void 0 ? void 0 : pagePath.slice(2))),
                hrefLang: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                href: handleCanonicalUrl("".concat(nextPublicBaseUrl, "en").concat(pagePath === null || pagePath === void 0 ? void 0 : pagePath.slice(2))),
                hrefLang: "x-default"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                href: handleCanonicalUrl("".concat(nextPublicBaseUrl, "ar").concat(pagePath === null || pagePath === void 0 ? void 0 : pagePath.slice(2))),
                hrefLang: "ar"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image ? image : "".concat(nextPublicBaseUrl).concat(_public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src.slice */ .Z.src.slice(1))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "image:width",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "image:height",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image ? image : "".concat(nextPublicBaseUrl).concat(_public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src.slice */ .Z.src.slice(1))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat(nextPublicBaseUrl).concat(pagePath === "/" ? "" : pagePath)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "article"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "muvi Cinemas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:site",
                content: "@muvicinemas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:creator",
                content: "@muvicinemas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image ? image : "".concat(nextPublicBaseUrl).concat(_public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src.slice */ .Z.src.slice(1))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image:width",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image:height",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: "".concat(nextPublicBaseUrl).concat(pagePath === "/" ? "" : pagePath)
            }),
            (noIndex || noFollow) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: noIndex && noFollow ? "noindex,nofollow" : noIndex ? "noindex" : "nofollow"
            }),
            !!components && components()
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Seo);


/***/ }),

/***/ 54087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91057);
/* harmony import */ var _mui_icons_material_ErrorOutline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32141);



var InputAdornmentComponent = function(param) {
    var errorCondition = param.errorCondition;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        position: "end",
        children: errorCondition ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ErrorOutline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            color: "error"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InputAdornmentComponent);


/***/ }),

/***/ 90820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RequiredGrayIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);
/* harmony import */ var _image_box_future__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58718);



var requiredGrayIcon = "/images/private-booking/requiredGray.svg";
var RequiredGrayIcon = function() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_1__/* .ImageBoxFuture */ .z, {
        img: requiredGrayIcon,
        title: intl.formatMessage({
            id: "global.all_required"
        }),
        objectFit: "contain",
        sx: {
            mr: "8px",
            height: "24px",
            width: "24px"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RequiredGrayIcon);


/***/ }),

/***/ 6825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kb": function() { return /* binding */ COMPLAINT; },
/* harmony export */   "WA": function() { return /* binding */ complaintSubCategoryList; },
/* harmony export */   "ac": function() { return /* binding */ ONLINE_BOOKING; },
/* harmony export */   "ap": function() { return /* binding */ I_CAN_NOT_BOOK_A_TICKET; },
/* harmony export */   "df": function() { return /* binding */ onlineSubCategoryList; },
/* harmony export */   "wA": function() { return /* binding */ categoryList; }
/* harmony export */ });
/* unused harmony exports MOVIES_INQUIRY, GENERAL_INQUIRY */
var COMPLAINT = "COMPLAINT";
var ONLINE_BOOKING = "ONLINE_BOOKING";
var MOVIES_INQUIRY = "MOVIES_INQUIRY";
var GENERAL_INQUIRY = "GENERAL_INQUIRY";
var I_CAN_NOT_BOOK_A_TICKET = "I_CAN_NOT_BOOK_A_TICKET";
var categoryList = [
    ONLINE_BOOKING,
    COMPLAINT,
    MOVIES_INQUIRY,
    GENERAL_INQUIRY
];
var complaintSubCategoryList = [
    "I_AM_NOT_HAPPY_WITH_THE_CLEANLINESS_OF_THE_CINEMA",
    "I_HAVE_WAITED_TOO_LONG_IN_THE_QUEUE",
    "I_AM_NOT_SATISFIED_WITH_THE_FOOD_AND_BEVERAGES_SERVED",
    "I_AM_UNHAPPY_ABOUT_THE_SERVICE_OF_STAFF",
    "I_AM_UNHAPPY_WITH_THE_TEMPERATURE_OF_THE_CINEMA",
    "I_AM_UNHAPPY_WITH_THE_QUALITY_OF_THE_MOVIE_SHOWN",
    "OTHERS", 
];
var onlineSubCategoryList = [
    "I_DID_NOT_RECEIVE_MY_TICKET",
    "I_BOOKED_THE_WRONG_TICKET",
    "MY_PAYMENT_IS_UNSUCCESSFUL",
    "I_RECEIVED_ERROR_MESSAGE",
    "I_CAN_NOT_BOOK_A_TICKET", 
];


/***/ }),

/***/ 22010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ excludedCountriesList; }
/* harmony export */ });
var excludedCountriesList = [
    "il",
    "ca",
    "us",
    "kz",
    "do",
    "pr"
];


/***/ }),

/***/ 33224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SeoPagesEnum; }
/* harmony export */ });
var SeoPagesEnum;
(function(SeoPagesEnum) {
    SeoPagesEnum["termsAndCondition"] = "TERMS_CONDITIONS";
    SeoPagesEnum["privacyPolicy"] = "PRIVACY_POLICY";
    SeoPagesEnum["contactUs"] = "CONTACT_US";
    SeoPagesEnum["aboutUs"] = "ABOUT_US";
    SeoPagesEnum["vouchersHowTo"] = "VOUCHERS_HOW_TO";
    SeoPagesEnum["privateBooking"] = "PRIVATE_BOOKINGS";
    SeoPagesEnum["foodMenu"] = "FOOD_MENU";
    SeoPagesEnum["offers"] = "OFFERS";
    SeoPagesEnum["cinemas"] = "CINEMAS";
    SeoPagesEnum["experiences"] = "EXPERIENCES";
    SeoPagesEnum["finder"] = "FINDER";
    SeoPagesEnum["home"] = "HOME";
})(SeoPagesEnum || (SeoPagesEnum = {}));


/***/ }),

/***/ 36575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ findSeoInsidePage; }
/* harmony export */ });
/**
 * It takes an array of PageMetaDataModel objects and a pageEnum string and returns the
 * PageMetaDataModel object that matches the pageEnum string
 * @param {PageMetaDataModel[]} array - PageMetaDataModel[] - this is the array of objects that we are
 * searching through.
 * @param {string} pageEnum - This is the page enum that you want to find the SEO data for.
 * @returns the first item in the array that matches the pageEnum.
 */ function findSeoInsidePage(array, pageEnum) {
    return array === null || array === void 0 ? void 0 : array.find(function(item) {
        return item.page === pageEnum;
    });
}


/***/ }),

/***/ 47488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gr": function() { return /* reexport */ useGetCinemaDetails; },
  "ve": function() { return /* reexport */ useGetCinemaList; },
  "L8": function() { return /* reexport */ useGetCinemas; }
});

// UNUSED EXPORTS: getCinemaList, useGetCinema

// EXTERNAL MODULE: ./src/logic/libs/index.ts
var libs = __webpack_require__(81900);
// EXTERNAL MODULE: ./src/constants/cashing.ts
var cashing = __webpack_require__(29236);
;// CONCATENATED MODULE: ./src/logic/services/cinemas/services.ts



var url = "cinemas";
var getCinemaList = function(params) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return axiosInstance.get("".concat(url), _object_spread({
        params: params
    }, config)).then(function(res) {
        return res === null || res === void 0 ? void 0 : res.data;
    });
};
var useGetCinemaList = (0,libs/* createQuery */.rP)({
    url: "".concat(url),
    method: "get"
}, {
    staleTime: cashing/* long_term_cashing */.d,
    keepPreviousData: false
});
var useGetCinemaDetails = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url, "/unique-name/:slug")
});
var useGetCinemas = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url)
}, {
    staleTime: cashing/* long_term_cashing */.d,
    keepPreviousData: false
});
var useGetCinema = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url, "/unique-name/:slug")
});

;// CONCATENATED MODULE: ./src/logic/services/cinemas/index.ts




/***/ }),

/***/ 97016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ useGetPagesSeoMeta; }
});

// EXTERNAL MODULE: ./src/logic/libs/index.ts
var libs = __webpack_require__(81900);
// EXTERNAL MODULE: ./src/constants/cashing.ts
var cashing = __webpack_require__(29236);
;// CONCATENATED MODULE: ./src/logic/services/seo/services.ts


var url = "page-meta-data";
var useGetPagesSeoMeta = (0,libs/* createQuery */.rP)({
    url: "".concat(url),
    method: "get"
}, {
    staleTime: cashing/* long_term_cashing */.d
});

;// CONCATENATED MODULE: ./src/logic/services/seo/index.ts




/***/ }),

/***/ 946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wE": function() { return /* binding */ aN2eN; },
  "AN": function() { return /* binding */ acceptOnlyNumberOnSafari; },
  "_5": function() { return /* binding */ checkIfPhoneNumberIsValid; },
  "P6": function() { return /* binding */ getBrowserHeight; },
  "wi": function() { return /* binding */ getBrowserWidth; },
  "pg": function() { return /* binding */ getCreditCardIcon; },
  "lC": function() { return /* binding */ getDeviceTimeZone; },
  "CA": function() { return /* binding */ getDialCodeFromPhoneNumber; },
  "MQ": function() { return /* binding */ getInputCreditCardIcon; },
  "ij": function() { return /* binding */ getUserAgent; },
  "Wu": function() { return /* binding */ hashString; },
  "wO": function() { return /* binding */ muviPhoneNumberTrimmer; },
  "HV": function() { return /* binding */ sliceStringWithoutSpaces; }
});

// UNUSED EXPORTS: handleError, is500

// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumberFromString.js + 36 modules
var parsePhoneNumberFromString = __webpack_require__(32260);
;// CONCATENATED MODULE: ./public/icons/credit-cards/amex.png
/* harmony default export */ var amex = ({"src":"/_next/static/media/amex.00effc3f.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAwUlEQVR42mMgDCpPs+m3nFNw7rqgaNNxXtEaiJ2AbK3mcwoMFafZGPjqz2YDFf1nKD31k6Hs1G8QBrOrzvwXBMkxFJ+qzJh97f/krff/9m66979z/V0wO2bqlf8MRacqGRjrzlZqNJ/737Xh7t+F+x//n7Hz4f8FB578rVx26z9D4clKBs46oDHVZ/4DrfkJxL+B9v4G8n8y1J75zw6SA3LYZBrOKsg1nFVUbTqrqNt8TlGw7owiQ80ZBaAiNoKeBACMMWWpr/OjkgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/logic/services/credit-cards/models.ts
var models = __webpack_require__(77364);
;// CONCATENATED MODULE: ./public/icons/credit-cards/mada.png
/* harmony default export */ var mada = ({"src":"/_next/static/media/mada.b028ab3c.png","height":17,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAbUlEQVR4nGPknHHnFQPD////mFg4+V4/7BCtdrjzx8hOlPH7+9cMDAyqjEkrF80BKWBkYuL49u7D8jXpue/ULax+/v74SYSBgfEvY8cO/lf/GRj/MzH/5XzzmK+nO0nkq67JX/5fXxkZgSbwAgCTrCrIooH8/AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/icons/credit-cards/mastercard.png
/* harmony default export */ var mastercard = ({"src":"/_next/static/media/mastercard.f9f00a76.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAbFBMVEU+PUc9OUcoOUgoNUgAPUwAO0kAFksAAE4bOUgZMUhCP0dCOUcAQUsAOkkAKEoAJ0oAAE46O0c5OUc6PEc6OUdEP0ZEOUdjUkRiUkRhNEXPkizLKzfwkRvvkBvtRSntRCkqOkglO0gqNkgkMkgH+QZ5AAAAHHRSTlMAAAAAAAAAAAYGICAhISEhIWtreXn5+fv7+/39pt2N7gAAAD1JREFUeNpjYGJkZWFnY2Bm4ODm5RHg4+JkEFIQkxQXVRJkEFGUlpORUhYGMeRlgQywlARQCqKYH6gYph0AlfQEK6333cQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(81354);
;// CONCATENATED MODULE: ./public/icons/credit-cards/visa.png
/* harmony default export */ var visa = ({"src":"/_next/static/media/visa.4d3207ef.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAy0lEQVR42mMgCNT9d7GLeOxUdE/cp+iesE/RLGy3ogeQrem/S1HMcyc7g6LPzhw1v13/Gcy2/WSw2vabwWnHbwbTbT9lvHb+V/HblcPAYLC1Mirv0P/12+783bbn3v+VG2+C2Y6xe/8zOO6oZOBx21FpGLL7/4599/+u3nzr/+6DD/8fOvHkr3/afpCplQwqvrty5H12/gcZC9Txm8EFiI23/QSJKQPlGCSBDgG6QdEzaZ+iaehuRaOQ3Yq+KfsVlXx3Ksp772Qn6EsAFvFdgKeUO/IAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/logic/shared/index.ts







var EmptyUpComing = "/icons/my-booking/emptyUpComing.svg";
var PlaceholderCardIcon = "/icons/credit-cards/placeholder-card.svg";
/**
 * This TypeScript function returns the image source of a credit card icon based on its type.
 * @param {CreditCardType} type - Credit card type, which is an enum with possible values of Visa,
 * MasterCard, and Amex.
 * @returns A string representing the source of the icon for a given credit card type. If the type is
 * not recognized, a default icon source is returned.
 */ var getCreditCardIcon = function(type) {
    if (type === models/* CreditCardType.Visa */.O.Visa) return visa.src;
    else if (type === models/* CreditCardType.MasterCard */.O.MasterCard) return mastercard.src;
    else if (type === models/* CreditCardType.Amex */.O.Amex) return amex.src;
    else if (type === models/* CreditCardType.Mada */.O.Mada) return mada.src;
    else return EmptyUpComing;
};
/**
 * This TypeScript function returns a credit card icon based on the type of credit card entered.
 * @param {ValidationCreditCardType} type - ValidationCreditCardType, which is a string representing
 * the type of credit card (e.g. 'visa', 'mastercard', 'american-express').
 * @returns The function `getInputCreditCardIcon` returns a string which is the icon of the credit card
 * type passed as an argument. If the argument is not one of the supported credit card types, it
 * returns a placeholder card icon.
 */ var getInputCreditCardIcon = function(type) {
    if (type === "visa") return getCreditCardIcon(models/* CreditCardType.Visa */.O.Visa);
    else if (type === "mastercard") return getCreditCardIcon(models/* CreditCardType.MasterCard */.O.MasterCard);
    else if (type === "american-express") return getCreditCardIcon(models/* CreditCardType.Amex */.O.Amex);
    else if (type === "mada") return getCreditCardIcon(models/* CreditCardType.Mada */.O.Mada);
    else return PlaceholderCardIcon;
};
/**
 * It takes a phone number and a dial code, checks if the first number is equal to '0' and removes it,
 * removes all non-digits chars, and returns the phone number with the dial code.
 * @param {string} phoneNumber - string - the phone number that you want to trim
 * @param {string} dialCode - "+91"
 * @returns A function that takes two parameters, phoneNumber and dialCode.
 */ var muviPhoneNumberTrimmer = function(phoneNumber, dialCode) {
    /* Removing the dial code from the phone number. */ phoneNumber = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.substring(dialCode.length + 1);
    /* Checking if the first number is equal to '0' and removing it. */ if (phoneNumber.charAt(0) === "0") {
        phoneNumber = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.substring(1);
    }
    /* Removing all non-digits chars. */ phoneNumber = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/\D/g, "");
    /* Concatenating the dialCode and the phoneNumber. */ phoneNumber = "+".concat(dialCode).concat(phoneNumber);
    return phoneNumber;
};
var getDialCodeFromPhoneNumber = function(phoneNumber) {
    // Parse the phone number
    var parsedNumber = (0,parsePhoneNumberFromString/* parsePhoneNumberFromString */._)(phoneNumber);
    // Extract the dial code
    var dialCode = parsedNumber.countryCallingCode;
    return dialCode;
};
var is500 = function(error) {
    var ref, ref1;
    return ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) >= 500 && ((ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) !== 503;
};
var handleError = function(error) {
    var ref;
    if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) >= 500) return {
        redirect: {
            destination: "500",
            permanent: false
        }
    };
};
var getUserAgent = function() {
    return window.navigator.userAgent;
};
var getDeviceTimeZone = function() {
    return new Date().getTimezoneOffset();
};
var getBrowserWidth = function() {
    return Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth);
};
var getBrowserHeight = function() {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight);
};
var checkIfPhoneNumberIsValid = function(phoneNumber, countryCode) {
    var _phoneNumber = (0,parsePhoneNumberFromString/* parsePhoneNumberFromString */._)(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.toString(), countryCode);
    return (_phoneNumber === null || _phoneNumber === void 0 ? void 0 : _phoneNumber.isValid()) === true;
};
/**
 * It replaces each Arabic digit in the input string with its equivalent in the string '٠١٢٣٤٥٦٧٨٩'
 */ var aN2eN = function(s) {
    return s.replace(/[٠-٩]/g, function(d) {
        return "٠١٢٣٤٥٦٧٨٩".indexOf(d);
    });
};
var hashString = function(inputString) {
    return (0,crypto_js.SHA512)(inputString).toString();
};
var sliceStringWithoutSpaces = function(str, number) {
    return str.replace(/ /g, "").substring(0, number || 8);
};
var acceptOnlyNumberOnSafari = function(e) {
    if (e && !/[0-9]/.test(e.key) && // Allow only numbers
    e.key !== "Backspace" && // Allow backspace
    e.key !== "Tab" && // Allow tab
    e.key !== "ArrowLeft" && // Allow left arrow
    e.key !== "ArrowRight" && // Allow right arrow
    e.key !== "Delete" && // Allow delete
    e.key !== "Enter" && // Allow enter
    e.key !== "Escape" // Allow escape
    ) {
        e.preventDefault();
    }
};


/***/ }),

/***/ 76635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_contact_us; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(22715);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(56815);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(33841);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 2 modules
var Select = __webpack_require__(62482);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(63931);
// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(36872);
// EXTERNAL MODULE: ./src/constants/contact-us.ts
var contact_us = __webpack_require__(6825);
// EXTERNAL MODULE: ./src/logic/services/index.ts + 21 modules
var services = __webpack_require__(10029);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/logic/shared/index.ts + 4 modules
var shared = __webpack_require__(946);
// EXTERNAL MODULE: ./src/logic/state/index.ts + 18 modules
var state = __webpack_require__(42125);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 4 modules
var dist_es = __webpack_require__(32512);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Box/Box.js + 15 modules
var Box_Box = __webpack_require__(69082);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
;// CONCATENATED MODULE: ./src/components/shared/upload-file-component/styles.ts
var filesContainer = {
    display: "inline-flex",
    width: "31px",
    height: "38px",
    boxSizing: "border-box"
};
var dropzoneContainer = {
    flex: "1 1 0%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderWidth: "1px",
    borderRadius: "2px",
    borderColor: "rgb(238, 238, 238)",
    borderStyle: "dashed",
    backgroundColor: "transparent",
    color: "rgb(189, 189, 189)",
    outline: "currentcolor none medium",
    transition: "border 0.24s ease-in-out 0s",
    height: "auto",
    minHeight: "150px",
    position: "relative",
    maxWidth: "100%"
};
var dropzone = {
    flex: "1 1 0%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderWidth: "1px",
    color: "rgb(189, 189, 189)",
    outline: "currentcolor none medium",
    transition: "border 0.24s ease-in-out 0s",
    cursor: "pointer",
    justifyContent: "center"
};
var fileContainer = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
    flexDirection: "column",
    // position: 'relative',
    width: "100%"
};
var fileImg = {
    display: "block",
    width: "auto",
    borderRadius: "10px",
    height: "100%",
    background: "white",
    objectFit: "contain",
    position: "relative"
};
var fileName = {
    fontSize: "12px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "inline-block",
    maxWidth: "100px"
};
var deleteIcon = {};
var loader = {
    position: "absolute"
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Delete.js
var Delete = __webpack_require__(41733);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(66489);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/circularProgressClasses.js
var circularProgressClasses = __webpack_require__(22346);
;// CONCATENATED MODULE: ./src/components/shared/upload-file-component/upload-file-loader.tsx






var FileLoaderComponent = function(props) {
    var customColor = props.customColor;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: loader,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                sx: {
                    color: theme.palette.grey[300]
                },
                variant: "determinate",
                size: 30,
                thickness: 4,
                value: 100
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                variant: "indeterminate",
                disableShrink: true,
                sx: (0,_define_property/* default */.Z)({
                    color: customColor !== null && customColor !== void 0 ? customColor : "primary",
                    animationDuration: "550ms",
                    position: "absolute",
                    left: 0
                }, "& .".concat(circularProgressClasses/* default.circle */.Z.circle), {
                    strokeLinecap: "round"
                }),
                size: 30,
                thickness: 4
            })
        ]
    });
};
/* harmony default export */ var upload_file_loader = (FileLoaderComponent);

// EXTERNAL MODULE: ./src/components/shared/image-box-future.tsx
var image_box_future = __webpack_require__(58718);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/RemoveRedEye.js
var RemoveRedEye = __webpack_require__(6714);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/@alpha.apps/react-common/dist/index.js + 6 modules
var dist = __webpack_require__(46080);
// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
;// CONCATENATED MODULE: ./src/components/shared/upload-file-component/upload-file-component.tsx


















var fileIcon = "/icons/contact-us/fileIcon.svg";
var uploadFileIcon = "/icons/contact-us/uploadFileIcon.svg";
var upload_file_component_deleteIcon = "/icons/contact-us/deleteIcon.svg";
var FileUploadComponent = function(props) {
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)([]), files = ref[0], setFiles = ref[1];
    var ref1 = (0,react.useState)([]), initFiles = ref1[0], setInitFiles = ref1[1];
    var ref2 = (0,react.useState)(props.errorFile || false), errorFileCondition = ref2[0], setErrorFileCondition = ref2[1];
    var ref3 = (0,react.useState)(false), maxFileCondition = ref3[0], setMaxFileCondition = ref3[1];
    var submittedFiles = (0,react.useRef)([]);
    var onDropFile = (0,react.useCallback)(function(acceptedFiles) {
        submittedFiles.current = acceptedFiles;
        setErrorFileCondition(false);
        setMaxFileCondition(false);
        if (props.imgType) {
            submittedFiles.current = acceptedFiles.map(function(file) {
                return Object.assign(file, {
                    preview: URL.createObjectURL(file)
                });
            });
        }
        setFiles(function(prev) {
            if (props.multiple === undefined) {
                if (props.maxFiles) {
                    if ((0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(submittedFiles.current)).length > props.maxFiles) {
                        setErrorFileCondition(true);
                        return prev;
                    }
                }
                if ((0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(submittedFiles.current)).length > 1) {
                    setErrorFileCondition(true);
                    return prev;
                }
            }
            props.handleFiles((0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(submittedFiles.current)));
            return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(submittedFiles.current));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var removeFile = (0,react.useCallback)(function(e, fileIndex, initFile) {
        if (initFile) {
            e.preventDefault();
            e.stopPropagation();
            var newInitFiles = cloneDeep_default()(initFiles);
            newInitFiles.splice(fileIndex, 1);
            setInitFiles(newInitFiles);
            setFiles(newInitFiles);
            props.handleFiles(newInitFiles);
        } else {
            setErrorFileCondition(false);
            setMaxFileCondition(false);
            e.preventDefault();
            e.stopPropagation();
            var newFiles = cloneDeep_default()(files);
            newFiles.splice(fileIndex, 1);
            setFiles(newFiles);
            setInitFiles(newFiles);
            props.handleFiles(newFiles);
        }
    }, [
        files,
        initFiles,
        props
    ]);
    var ref4 = (0,dist_es/* useDropzone */.uI)({
        accept: props.accept,
        maxFiles: props.maxFiles,
        maxSize: props.maxSize,
        minSize: props.minSize,
        multiple: props.multiple || false,
        noDrag: props.noDrag || false,
        onDrop: onDropFile,
        onDropRejected: (0,react.useCallback)(function() {
            setErrorFileCondition(true);
        }, [])
    }), fileRejections = ref4.fileRejections, getRootProps = ref4.getRootProps, getInputProps = ref4.getInputProps;
    (0,react.useEffect)(function() {
        if (props.initValues && (0,dist/* isArray */.kJ)(props.initValues) && props.initValues.length > 0) {
            var submittedValues = props.initValues.map(function(initVal) {
                return {
                    preview: initVal
                };
            });
            setInitFiles(submittedValues);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (props.initValues === undefined) {
            setInitFiles([]);
            setFiles([]);
        }
    }, [
        props.initValues
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                children: props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "subtitle1",
                    mb: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: props.title
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                sx: props.dropzoneContainerStyle ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.dropzoneContainerStyle), {
                    position: "relative"
                }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dropzoneContainer), {
                    borderColor: "".concat(props.requiredUploadImage ? theme.palette.error.light : theme.palette.grey[30])
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getRootProps({})), {
                    sx: dropzone,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({}, getInputProps())),
                        files.length === 0 && initFiles.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                            component: "div",
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center",
                                height: {
                                    tablet: (0,typography/* pxToRem */.Q)(193),
                                    mobile: "193px"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                    img: uploadFileIcon,
                                    title: intl.formatMessage({
                                        id: "global.upload_file_icon"
                                    }),
                                    objectFit: "contain",
                                    sx: {
                                        p: {
                                            tablet: (0,typography/* pxToRem */.Q)(8),
                                            mobile: "8px"
                                        },
                                        height: {
                                            tablet: (0,typography/* pxToRem */.Q)(45),
                                            mobile: "45px"
                                        },
                                        width: {
                                            tablet: (0,typography/* pxToRem */.Q)(34),
                                            mobile: "34px"
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "p",
                                    sx: {
                                        textAlign: "center",
                                        fontWeight: 400,
                                        fontSize: {
                                            tablet: (0,typography/* pxToRem */.Q)(16),
                                            mobile: "16px"
                                        },
                                        lineHeight: "150%",
                                        color: theme.palette.grey[80]
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: props.dropzoneText ? props.dropzoneText : "global.drag_drop_file"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "p",
                                    sx: {
                                        textAlign: "center",
                                        fontWeight: 400,
                                        fontSize: {
                                            tablet: (0,typography/* pxToRem */.Q)(16),
                                            mobile: "16px"
                                        },
                                        lineHeight: "150%",
                                        color: theme.palette.secondary.main,
                                        mb: {
                                            tablet: (0,typography/* pxToRem */.Q)(14),
                                            mobile: "14px"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: props.dropzoneText ? props.dropzoneText : "global.or"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    id: "avatar-upload",
                                    variant: "secondary",
                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveRedEye/* default */.Z, {
                                        sx: {
                                            fontSize: {
                                                tablet: (0,typography/* pxToRem */.Q)(16),
                                                mobile: "16px"
                                            },
                                            mr: {
                                                tablet: (0,typography/* pxToRem */.Q)(8),
                                                mobile: "8px"
                                            },
                                            width: {
                                                tablet: (0,typography/* pxToRem */.Q)(16),
                                                mobile: "16px"
                                            },
                                            height: {
                                                tablet: (0,typography/* pxToRem */.Q)(16),
                                                mobile: "16px"
                                            }
                                        }
                                    }),
                                    sx: {
                                        width: {
                                            tablet: (0,typography/* pxToRem */.Q)(143),
                                            mobile: "143px"
                                        },
                                        height: {
                                            tablet: (0,typography/* pxToRem */.Q)(40),
                                            mobile: "40px"
                                        },
                                        p: 0,
                                        borderRadius: "12px !important",
                                        fontWeight: "700",
                                        fontSize: {
                                            tablet: (0,typography/* pxToRem */.Q)(16),
                                            mobile: "16px"
                                        },
                                        lineHeight: " 150%",
                                        display: "flex",
                                        ".MuiButton-startIcon": {
                                            mr: 0
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: props.dropzoneText ? props.dropzoneText : "global.browse_file"
                                    })
                                })
                            ]
                        }),
                        files && files.length > 0 ? files.map(function(file, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    maxWidth: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        sx: filesContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                            children: [
                                                !props.isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    sx: {
                                                        backgroundColor: "#FDE2EA",
                                                        position: "absolute",
                                                        top: "8px",
                                                        right: "8px",
                                                        borderRadius: "50%",
                                                        width: "24px",
                                                        minWidth: "auto",
                                                        height: "24px",
                                                        p: "4px"
                                                    },
                                                    onClick: function(e) {
                                                        return removeFile(e, i, true);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                                        img: upload_file_component_deleteIcon,
                                                        title: intl.formatMessage({
                                                            id: "global.upload_file_icon"
                                                        }),
                                                        objectFit: "contain",
                                                        sx: {
                                                            width: "20px",
                                                            height: "20px"
                                                        }
                                                    })
                                                }),
                                                !props.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                    component: "img",
                                                    alt: "",
                                                    src: file.type === "application/pdf" ? fileIcon : file.preview,
                                                    sx: fileImg
                                                }) : props.isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(upload_file_loader, {})
                                            ]
                                        })
                                    }, file.name),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "subtitle2",
                                        sx: {
                                            fontSize: "12px",
                                            color: theme.palette.grey[80],
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                            display: "inline-block",
                                            maxWidth: "95%",
                                            mt: "8px"
                                        },
                                        children: file.name
                                    })
                                ]
                            }, file.name);
                        }) : initFiles && initFiles.map(function(file, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                    sx: props.filesContainerStyle ? props.filesContainerStyle : filesContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Box/* default */.Z, {
                                        sx: props.fileContainerStyle ? props.fileContainerStyle : fileContainer,
                                        children: [
                                            !props.isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {
                                                sx: {
                                                    position: "absolute",
                                                    right: "-0.75rem",
                                                    top: "-0.75rem",
                                                    borderRadius: "3px",
                                                    color: theme.palette.grey[600],
                                                    background: theme.palette.action.hover,
                                                    cursor: "pointer",
                                                    transition: "all ease-in-out .3s",
                                                    ":hover": {
                                                        color: theme.palette.grey[200],
                                                        background: theme.palette.grey[500]
                                                    }
                                                },
                                                onClick: function(e) {
                                                    return removeFile(e, i, true);
                                                }
                                            }),
                                            !props.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                                    component: "img",
                                                    alt: "",
                                                    src: file.preview,
                                                    sx: props.fileImgStyle ? props.fileImgStyle : fileImg
                                                })
                                            }) : props.isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(upload_file_loader, {})
                                        ]
                                    })
                                }, file.preview)
                            }, file.preview);
                        }),
                        errorFileCondition && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body1",
                            gutterBottom: true,
                            color: theme.palette.error.light,
                            children: [
                                (maxFileCondition || !props.multiple) && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "global.max_files"
                                }),
                                (maxFileCondition || !props.multiple) && (props.maxFiles ? props.maxFiles : 1),
                                fileRejections.map(function(param) {
                                    var file = param.file, errors = param.errors;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
                                        children: errors.map(function(e) {
                                            return e.code === "too-many-files" ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    file.name,
                                                    ": ",
                                                    e.message
                                                ]
                                            }, e.code);
                                        })
                                    }, file.name);
                                })
                            ]
                        })
                    ]
                }))
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/shared/Input-adornment-component.tsx
var Input_adornment_component = __webpack_require__(54087);
// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 1 modules
var LoadingButton = __webpack_require__(31812);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./src/components/shared/required-gray-icon.tsx
var required_gray_icon = __webpack_require__(90820);
// EXTERNAL MODULE: ./src/components/seo/seo.tsx
var seo = __webpack_require__(89183);
// EXTERNAL MODULE: ./src/constants/seo-pages-enum.ts
var seo_pages_enum = __webpack_require__(33224);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/constants/phone-numbers.ts
var phone_numbers = __webpack_require__(22010);
// EXTERNAL MODULE: ./src/logic/helpers/find-seo-inside-page.ts
var find_seo_inside_page = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/lodash/isObject.js
var isObject = __webpack_require__(13218);
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/logic/hooks/index.ts + 27 modules
var hooks = __webpack_require__(7663);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/logic/services/cinemas/index.ts + 1 modules
var services_cinemas = __webpack_require__(47488);
// EXTERNAL MODULE: ./src/logic/services/seo/index.ts + 1 modules
var services_seo = __webpack_require__(97016);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./src/logic/types/data-layer-models.ts
var data_layer_models = __webpack_require__(58022);
// EXTERNAL MODULE: ./src/logic/shared/data-layer-events.ts
var data_layer_events = __webpack_require__(60986);
;// CONCATENATED MODULE: ./src/pages/contact-us.tsx




































var MuiPhoneNumber = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3626), __webpack_require__.e(6343)]).then(__webpack_require__.t.bind(__webpack_require__, 61803, 23)).then(function(component) {
        return component.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61803)
            ];
        }
    },
    ssr: false
});
var ContactUs = function(param) {
    var path = param.path;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
    var ref33 = (0,services_seo/* useGetPagesSeoMeta */._)(), seoDataList = ref33.data;
    var seoPage = (0,find_seo_inside_page/* findSeoInsidePage */.W)(seoDataList === null || seoDataList === void 0 ? void 0 : seoDataList.pageMetaData, seo_pages_enum/* SeoPagesEnum.contactUs */.E.contactUs);
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var ref34 = (0,router.useRouter)(), locale = ref34.locale, asPath = ref34.asPath;
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var ref35 = (0,react.useState)("KSA"), countryCode_contact = ref35[0], setCountryCode_contact = ref35[1];
    var user = (0,state/* useAuth */.aC)(function(s) {
        return s.user;
    }, shallow/* default */.Z);
    var guest = (0,state/* useGuest */.Js)(function(s) {
        return s.guest;
    }, shallow/* default */.Z);
    var ref36 = (0,hooks/* useCity */.hA)(), cityId = ref36.cityId, getCity = ref36.getCity;
    var ref37 = (0,react.useState)(cityId), selectedCity = ref37[0], setSelectedCity = ref37[1];
    var ref38 = (0,react.useState)(), selectedCinema = ref38[0], setSelectedCinema = ref38[1];
    var ref39 = (0,react.useState)(), errorFile = ref39[0], setErrorFile = ref39[1];
    var ref40 = (0,react.useState)(""), recaptchaValue = ref40[0], setRecaptchaValue = ref40[1];
    var ref41 = (0,react.useState)(undefined), fileInitialValue = ref41[0], setFileInitialValue = ref41[1];
    var ref42 = (0,react.useState)(undefined), submittedImage = ref42[0], setSubmittedImage = ref42[1];
    var recaptchaRef = (0,react.useRef)(null);
    var ref43 = (0,react.useState)(null), selectedCountry = ref43[0], setSelectedCountry = ref43[1];
    var cities = (0,state/* useCities */.M1)(function(s) {
        return s.cities;
    }, shallow/* default */.Z);
    var publicRuntimeConfig = config_default()().publicRuntimeConfig;
    var ref44 = (0,services/* useGetSettings */.Y4)(), allCmsSetting = ref44.data;
    var ref45 = (0,services_cinemas/* useGetCinemas */.L8)({
        params: {
            cityId: selectedCity
        }
    }), cinemas = ref45.data;
    var uploadFile = (0,services/* useFileService */.fb)();
    var getSubmittedFormData = (0,react.useCallback)(function() {
        var formData = new FormData();
        if (isObject_default()(submittedImage)) {
            formData.append("file", submittedImage);
            return formData;
        }
        return undefined;
    }, [
        submittedImage
    ]);
    var schema = es/* object */.Ry({
        phoneNumber: es/* string */.Z_().test("test-valid-phone", intl.formatMessage({
            id: "global.phoneNumber.notValid"
        }), function(value) {
            if (value) {
                return (0,shared/* checkIfPhoneNumberIsValid */._5)(value, countryCode_contact);
            }
        }),
        customerName: es/* string */.Z_().trim().required().min(2).max(101),
        // .matches(/^[aA-zZ\s\u0621-\u064A]+$/),
        email: es/* string */.Z_().email().required(),
        // .matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/),
        cityId: es/* string */.Z_().required(),
        cinemaId: es/* string */.Z_().required(),
        category: es/* string */.Z_().required(),
        subject: es/* string */.Z_().trim().required().min(2).max(50),
        description: es/* string */.Z_().trim().required().min(2).max(200),
        subcategory: es/* string */.Z_().when("category", {
            is: function(category) {
                return category === contact_us/* COMPLAINT */.Kb || category === contact_us/* ONLINE_BOOKING */.ac;
            },
            then: es/* string */.Z_().required()
        })
    });
    var ref46 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema),
        mode: "all",
        defaultValues: {
            customerName: (user === null || user === void 0 ? void 0 : user.firstName) ? (user === null || user === void 0 ? void 0 : user.firstName) + " " + (user === null || user === void 0 ? void 0 : user.lastName) : "",
            email: (user === null || user === void 0 ? void 0 : user.email) || "",
            phoneNumber: (user === null || user === void 0 ? void 0 : user.phoneNumber) || undefined,
            cityId: "".concat(selectedCity),
            cinemaId: null,
            category: "",
            subject: "",
            description: "",
            subcategory: ""
        }
    }), register = ref46.register, setValue = ref46.setValue, handleSubmit = ref46.handleSubmit, trigger = ref46.trigger, getValues = ref46.getValues, reset = ref46.reset, clearErrors = ref46.clearErrors, resetField = ref46.resetField, _formState = ref46.formState, errors = _formState.errors, touchedFields = _formState.touchedFields, isValid = _formState.isValid;
    var createContactUs = (0,services/* useCreateContactUs */.IF)();
    var onSubmit = handleSubmit(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var customerName, phoneNumber, cityId, cinemaId, category, subject, description, email, subcategory, contactUsData, submittedFormData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                customerName = param.customerName, phoneNumber = param.phoneNumber, cityId = param.cityId, cinemaId = param.cinemaId, category = param.category, subject = param.subject, description = param.description, email = param.email, subcategory = param.subcategory;
                contactUsData = {
                    customerName: customerName,
                    phoneNumber: user ? phoneNumber : (0,shared/* muviPhoneNumberTrimmer */.wO)(phoneNumber, selectedCountry.dialCode),
                    cityId: +cityId,
                    cinemaId: +cinemaId,
                    category: category,
                    subcategory: subcategory,
                    description: description,
                    subject: subject,
                    email: email,
                    recaptchaResponse: recaptchaValue,
                    fileUrl: ""
                };
                submittedFormData = getSubmittedFormData();
                Boolean(submittedImage) ? uploadFile.safeMutateAsync({
                    data: submittedFormData
                }, {
                    onSuccess: function(res) {
                        sendData(contactUsData, res === null || res === void 0 ? void 0 : res.url);
                    }
                }) : sendData(contactUsData, undefined);
                return [
                    2
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }());
    var sendData = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(contactUsData, urlFile) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setFileInitialValue(urlFile);
                        return [
                            4,
                            createContactUs.safeMutateAsync({
                                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contactUsData), {
                                    fileUrl: urlFile
                                })
                            }, {
                                onSuccess: function() {
                                    var ref, ref1;
                                    var data = {
                                        event: data_layer_models/* EventTypes.CONTACT_FORM_SUCCESS */.G.CONTACT_FORM_SUCCESS,
                                        page_section: asPath,
                                        page_title: document.title,
                                        page_url: document.URL,
                                        lead_type: intl.formatMessage({
                                            id: "contact_us.".concat(contactUsData.category)
                                        }),
                                        mall: cinemas.cinema.find(function(cinema) {
                                            return cinema.id === contactUsData.cinemaId;
                                        }).name,
                                        location: (ref = getCity(cityId)) === null || ref === void 0 ? void 0 : ref.name
                                    };
                                    (0,data_layer_events/* triggerGAEvent */.S)(data);
                                    setSnack({
                                        isOpen: true,
                                        message: "contact_us.created_successfully",
                                        type: "success"
                                    });
                                    close();
                                    reset();
                                    if (user) {
                                        var ref2;
                                        setValue("phoneNumber", (ref2 = user === null || user === void 0 ? void 0 : user.phoneNumber) !== null && ref2 !== void 0 ? ref2 : "");
                                        var ref3;
                                        setValue("email", (ref3 = user === null || user === void 0 ? void 0 : user.email) !== null && ref3 !== void 0 ? ref3 : "");
                                        setValue("customerName", (user === null || user === void 0 ? void 0 : user.firstName) ? (user === null || user === void 0 ? void 0 : user.firstName) + " " + (user === null || user === void 0 ? void 0 : user.lastName) : "");
                                    }
                                    (ref1 = recaptchaRef.current) === null || ref1 === void 0 ? void 0 : ref1.reset();
                                    setSelectedCity(cityId || null);
                                    setSelectedCinema(null);
                                    setRecaptchaValue("");
                                    setFileInitialValue(undefined);
                                    setSubmittedImage(undefined);
                                    setErrorFile(false);
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(contactUsData, urlFile) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        createContactUs,
        reset,
        setSnack,
        user === null || user === void 0 ? void 0 : user.preferredCityId
    ]);
    var handleUploadFile = (0,react.useCallback)(function(files) {
        if (files.length > 0) {
            setSubmittedImage(files[0]);
        } else {
            setSubmittedImage(undefined);
        }
    }, []);
    var onChangeCaptcha = (0,react.useCallback)(function(value) {
        setRecaptchaValue(value);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setValue
    ]);
    (0,react.useEffect)(function() {
        setSelectedCinema(null);
    }, [
        selectedCity
    ]);
    (0,react.useEffect)(function() {
        clearErrors("customerName");
        clearErrors("email");
        if (user) {
            var ref;
            setValue("phoneNumber", (ref = user === null || user === void 0 ? void 0 : user.phoneNumber) !== null && ref !== void 0 ? ref : "");
            var ref1;
            setValue("email", (ref1 = user === null || user === void 0 ? void 0 : user.email) !== null && ref1 !== void 0 ? ref1 : "");
            setValue("customerName", (user === null || user === void 0 ? void 0 : user.firstName) ? (user === null || user === void 0 ? void 0 : user.firstName) + " " + (user === null || user === void 0 ? void 0 : user.lastName) : "");
            var ref2;
            setValue("cityId", (ref2 = user === null || user === void 0 ? void 0 : user.preferredCityId) !== null && ref2 !== void 0 ? ref2 : null);
            var ref3;
            setSelectedCity((ref3 = user === null || user === void 0 ? void 0 : user.preferredCityId) !== null && ref3 !== void 0 ? ref3 : null);
        } else {
            resetField("phoneNumber");
            resetField("customerName");
            resetField("email");
            setValue("phoneNumber", "");
            setValue("email", "");
            setValue("customerName", "");
            setValue("category", "");
            setValue("description", "");
            setValue("subject", "");
            setValue("subcategory", "");
            setValue("cinemaId", null);
            setSelectedCinema(null);
            var ref4;
            setValue("cityId", (ref4 = "".concat(guest === null || guest === void 0 ? void 0 : guest.preferredCityId)) !== null && ref4 !== void 0 ? ref4 : "");
            var ref5;
            setSelectedCity((ref5 = guest === null || guest === void 0 ? void 0 : guest.preferredCityId) !== null && ref5 !== void 0 ? ref5 : null);
            setFileInitialValue(undefined);
            setSubmittedImage(undefined);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    var subCategories = getValues("category") === contact_us/* COMPLAINT */.Kb ? contact_us/* complaintSubCategoryList */.WA : getValues("category") === contact_us/* ONLINE_BOOKING */.ac ? contact_us/* onlineSubCategoryList */.df : [];
    var ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56;
    var _obj;
    // const initFile = useMemo(() => fileInitialValue || submittedImage, [fileInitialValue,submittedImage]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: (seoPage === null || seoPage === void 0 ? void 0 : seoPage.titleTag) || intl.formatMessage({
                    id: "contact_us"
                }),
                canonical: seoPage === null || seoPage === void 0 ? void 0 : seoPage.canonicalURL,
                pagePath: path,
                description: (seoPage === null || seoPage === void 0 ? void 0 : seoPage.descriptionTag) || (allCmsSetting === null || allCmsSetting === void 0 ? void 0 : allCmsSetting.contactUsDescription),
                noFollow: seoPage === null || seoPage === void 0 ? void 0 : seoPage.hasFollow,
                noIndex: seoPage === null || seoPage === void 0 ? void 0 : seoPage.hasIndex,
                components: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script" // hubspot new script
                    , {
                        type: "text/javascript",
                        id: "hs-script-loader",
                        async: true,
                        defer: true,
                        src: "//js-eu1.hs-scripts.com/143790225.js"
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "section",
                sx: {
                    mb: (0,typography/* pxToRem */.Q)(122)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "h1",
                        sx: (0,_define_property/* default */.Z)({
                            fontSize: {
                                tablet: (0,typography/* pxToRem */.Q)(30),
                                mobile: "18px"
                            },
                            color: theme.palette.grey[80],
                            my: (0,typography/* pxToRem */.Q)(52),
                            fontWeight: 700,
                            px: {
                                laptop: (0,typography/* pxToRem */.Q)(128),
                                tablet: (0,typography/* pxToRem */.Q)(40),
                                mobile: "16px"
                            }
                        }, theme.breakpoints.down("tablet"), {
                            mt: "32px",
                            mb: "24px"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "contact_us"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: (_obj = {
                            marginBlockEnd: 5,
                            background: theme.palette.layout.bgSecondary,
                            maxWidth: "1102px",
                            pt: {
                                tablet: (0,typography/* pxToRem */.Q)(50),
                                mobile: "16px"
                            },
                            px: {
                                tablet: (0,typography/* pxToRem */.Q)(135),
                                mobile: "16px"
                            },
                            pb: {
                                tablet: (0,typography/* pxToRem */.Q)(44),
                                mobile: "25px"
                            },
                            mx: "auto",
                            mb: (0,typography/* pxToRem */.Q)(23),
                            borderRadius: (0,typography/* pxToRem */.Q)(25)
                        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(1134), {
                            m: (0,typography/* pxToRem */.Q)(16),
                            mt: (0,typography/* pxToRem */.Q)(40)
                        }), (0,_define_property/* default */.Z)(_obj, "mt", {
                            tablet: (0,typography/* pxToRem */.Q)(40),
                            mobile: "24px"
                        }), _obj),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "h4",
                                sx: {
                                    fontSize: {
                                        tablet: (0,typography/* pxToRem */.Q)(28),
                                        mobile: "20px"
                                    },
                                    color: theme.palette.primary.main,
                                    mb: {
                                        tablet: (0,typography/* pxToRem */.Q)(41),
                                        mobile: "8px"
                                    },
                                    lineHeight: {
                                        tablet: "32px",
                                        mobile: "30px"
                                    },
                                    fontWeight: 700,
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "contact_us.stay_connect"
                                })
                            }),
                            (allCmsSetting === null || allCmsSetting === void 0 ? void 0 : allCmsSetting.contactUsDescription) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "p",
                                sx: {
                                    fontSize: {
                                        tablet: (0,typography/* pxToRem */.Q)(24),
                                        mobile: "14px"
                                    },
                                    color: theme.palette.grey[70],
                                    mb: {
                                        tablet: (0,typography/* pxToRem */.Q)(24),
                                        mobile: "24px"
                                    },
                                    lineHeight: {
                                        tablet: "30px",
                                        mobile: "24px"
                                    },
                                    fontWeight: 400,
                                    textAlign: "center"
                                },
                                children: allCmsSetting.contactUsDescription
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                component: "div",
                                sx: {
                                    display: "flex",
                                    mb: {
                                        tablet: (0,typography/* pxToRem */.Q)(16),
                                        mobile: "20px"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(required_gray_icon/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        component: "p",
                                        sx: {
                                            fontSize: "14px",
                                            color: theme.palette.grey[50],
                                            lineHeight: "24px",
                                            fontWeight: 400
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "global.all_required"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    mt: 3,
                                    "&.MuiGrid-root>.MuiGrid-item": {
                                        pt: {
                                            tablet: (0,typography/* pxToRem */.Q)(32),
                                            mobile: "24px"
                                        }
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: 2,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            tablet: 6,
                                            mobile: 12,
                                            laptop: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        id: "contact-us-customerName",
                                                        disabled: Boolean((user === null || user === void 0 ? void 0 : user.firstName) && (user === null || user === void 0 ? void 0 : user.lastName)),
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.full_name"
                                                        }),
                                                        variant: "outlined"
                                                    }, register("customerName")), {
                                                        error: (ref47 = errors.customerName && touchedFields.customerName) !== null && ref47 !== void 0 ? ref47 : false,
                                                        InputProps: {
                                                            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                                errorCondition: errors.customerName && touchedFields.customerName
                                                            })
                                                        },
                                                        sx: {
                                                            "& fieldset span": {
                                                                opacity: (user === null || user === void 0 ? void 0 : user.firstName) ? "1!important" : "0",
                                                                transform: (user === null || user === void 0 ? void 0 : user.firstName) ? "translateY(-5px)" : "translateY(0)"
                                                            },
                                                            "&  label": {
                                                                opacity: !(user === null || user === void 0 ? void 0 : user.firstName) ? "1!important" : "0"
                                                            }
                                                        }
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                        error: true,
                                                        children: touchedFields.customerName && ((errors === null || errors === void 0 ? void 0 : (ref = errors.customerName) === null || ref === void 0 ? void 0 : ref.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.required"
                                                        }) : (errors === null || errors === void 0 ? void 0 : (ref1 = errors.customerName) === null || ref1 === void 0 ? void 0 : ref1.type) === "min" || (errors === null || errors === void 0 ? void 0 : (ref2 = errors.customerName) === null || ref2 === void 0 ? void 0 : ref2.type) === "max" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "global.please.enter.valid"
                                                                }),
                                                                "\xa0",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "global.full_name"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "global.min.two.max.fifty"
                                                                })
                                                            ]
                                                        }) : (errors === null || errors === void 0 ? void 0 : (ref3 = errors.customerName) === null || ref3 === void 0 ? void 0 : ref3.type) === "matches" && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.only.chars.allowed"
                                                        }))
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            tablet: 6,
                                            mobile: 12,
                                            laptop: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        id: "contact-us-email"
                                                    }, register("email")), {
                                                        disabled: Boolean(user === null || user === void 0 ? void 0 : user.email),
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.email"
                                                        }),
                                                        variant: "outlined",
                                                        error: !!(touchedFields.email && (errors === null || errors === void 0 ? void 0 : errors.email)),
                                                        InputProps: {
                                                            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                                errorCondition: errors.email && touchedFields.email
                                                            })
                                                        },
                                                        sx: {
                                                            "& fieldset span": {
                                                                opacity: (user === null || user === void 0 ? void 0 : user.email) ? "1!important" : "0",
                                                                transform: (user === null || user === void 0 ? void 0 : user.email) ? "translateY(-5px)" : "translateY(0)"
                                                            },
                                                            "&  label": {
                                                                opacity: !(user === null || user === void 0 ? void 0 : user.email) ? "1!important" : "0"
                                                            }
                                                        }
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                        error: true,
                                                        children: touchedFields.email && ((errors === null || errors === void 0 ? void 0 : (ref4 = errors.email) === null || ref4 === void 0 ? void 0 : ref4.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.required"
                                                        }) : ((errors === null || errors === void 0 ? void 0 : (ref5 = errors.email) === null || ref5 === void 0 ? void 0 : ref5.type) === "email" || (errors === null || errors === void 0 ? void 0 : (ref6 = errors.email) === null || ref6 === void 0 ? void 0 : ref6.type) === "matches") && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.validation.email"
                                                        }))
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            tablet: 6,
                                            mobile: 12,
                                            laptop: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                variant: "standard",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MuiPhoneNumber, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        excludeCountries: phone_numbers/* excludedCountriesList */.o,
                                                        value: ((ref7 = getValues()) === null || ref7 === void 0 ? void 0 : ref7.phoneNumber) || "",
                                                        error: (ref48 = (errors === null || errors === void 0 ? void 0 : (ref8 = errors.phoneNumber) === null || ref8 === void 0 ? void 0 : ref8.type) === "test-valid-phone" && touchedFields.phoneNumber) !== null && ref48 !== void 0 ? ref48 : false,
                                                        id: "phone",
                                                        InputLabelProps: {
                                                            sx: {
                                                                backgroundColor: "white",
                                                                paddingInline: "6px"
                                                            }
                                                        },
                                                        sx: {
                                                            "& svg": {
                                                                height: "1em",
                                                                legend: {
                                                                    width: 0
                                                                }
                                                            }
                                                        },
                                                        defaultCountry: "sa",
                                                        dir: "ltr"
                                                    }, register("phoneNumber")), {
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.phone_number"
                                                        }),
                                                        variant: "outlined",
                                                        disabled: Boolean(user === null || user === void 0 ? void 0 : user.phoneNumber),
                                                        onChange: function(e, country) {
                                                            setSelectedCountry(country);
                                                            setValue("phoneNumber", e);
                                                            var field = "phoneNumber";
                                                            var c = country === null || country === void 0 ? void 0 : country.countryCode.toString().toUpperCase();
                                                            if (field.includes("contact")) {
                                                                setCountryCode_contact(c);
                                                            }
                                                        },
                                                        InputProps: {
                                                            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                                errorCondition: ((ref9 = errors.phoneNumber) === null || ref9 === void 0 ? void 0 : ref9.type) === "test-valid-phone" && touchedFields.phoneNumber
                                                            })
                                                        }
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                        error: true,
                                                        children: ((ref10 = errors.phoneNumber) === null || ref10 === void 0 ? void 0 : ref10.type) === "test-valid-phone" && touchedFields.phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.phoneNumber.notValid"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            tablet: 6,
                                            mobile: 12,
                                            laptop: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                                        id: "city-label",
                                                        error: (ref49 = errors.cityId && touchedFields.cityId) !== null && ref49 !== void 0 ? ref49 : false,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.select_city"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        labelId: "city-label",
                                                        id: "contact-us-city",
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.select_city"
                                                        }),
                                                        value: selectedCity || getValues().cityId,
                                                        error: Boolean(errors.cityId)
                                                    }, register("cityId")), {
                                                        displayEmpty: true,
                                                        onChange: function(e) {
                                                            setSelectedCity(e.target.value);
                                                            setValue("cityId", e.target.value);
                                                            trigger();
                                                        },
                                                        MenuProps: {
                                                            BackdropProps: {
                                                                sx: {
                                                                    backgroundColor: "transparent",
                                                                    backdropFilter: "none"
                                                                }
                                                            }
                                                        },
                                                        renderValue: function() {
                                                            var ref, ref1;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                component: "span",
                                                                children: (ref1 = cities === null || cities === void 0 ? void 0 : (ref = cities.citiesList) === null || ref === void 0 ? void 0 : ref.find(function(city) {
                                                                    return city.id === selectedCity;
                                                                })) === null || ref1 === void 0 ? void 0 : ref1.name
                                                            });
                                                        },
                                                        children: cities === null || cities === void 0 ? void 0 : (ref11 = cities.citiesList) === null || ref11 === void 0 ? void 0 : ref11.map(function(city) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                value: city.id,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                                        checked: selectedCity === city.id
                                                                    }),
                                                                    city.name
                                                                ]
                                                            }, city.id);
                                                        })
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                        error: true,
                                                        children: touchedFields.cityId && ((errors === null || errors === void 0 ? void 0 : (ref12 = errors.cityId) === null || ref12 === void 0 ? void 0 : ref12.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.required"
                                                        }) : "")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            tablet: 6,
                                            mobile: 12,
                                            laptop: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                                        id: "cinema-label",
                                                        error: (ref50 = errors.cinemaId && touchedFields.cinemaId) !== null && ref50 !== void 0 ? ref50 : false,
                                                        sx: {
                                                            color: Boolean(selectedCity) || Boolean(getValues().cityId) ? theme.palette.grey[60] : theme.palette.grey[30]
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.select_cinema"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        labelId: "cinema-label",
                                                        id: "contact-us-cinema",
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.select_cinema"
                                                        }),
                                                        value: selectedCinema || "",
                                                        disabled: !Boolean(selectedCity) && !Boolean(getValues().cityId)
                                                    }, register("cinemaId")), {
                                                        error: Boolean(errors.cinemaId) && touchedFields.cinemaId,
                                                        onChange: function(e) {
                                                            setSelectedCinema(e.target.value);
                                                            setValue("cinemaId", e.target.value);
                                                            trigger();
                                                        },
                                                        MenuProps: {
                                                            BackdropProps: {
                                                                sx: {
                                                                    backgroundColor: "transparent",
                                                                    backdropFilter: "none"
                                                                }
                                                            }
                                                        },
                                                        displayEmpty: true,
                                                        renderValue: function() {
                                                            var ref, ref1;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                component: "span",
                                                                children: (ref1 = cinemas === null || cinemas === void 0 ? void 0 : (ref = cinemas.cinema) === null || ref === void 0 ? void 0 : ref.find(function(cinema) {
                                                                    return cinema.id === +selectedCinema;
                                                                })) === null || ref1 === void 0 ? void 0 : ref1.name
                                                            });
                                                        },
                                                        children: cinemas === null || cinemas === void 0 ? void 0 : (ref13 = cinemas.cinema) === null || ref13 === void 0 ? void 0 : ref13.map(function(cinema) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                value: cinema.id,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                                        checked: +selectedCinema === cinema.id
                                                                    }),
                                                                    cinema.name
                                                                ]
                                                            }, cinema.id);
                                                        })
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                        error: true,
                                                        children: touchedFields.cinemaId && ((errors === null || errors === void 0 ? void 0 : (ref14 = errors.cinemaId) === null || ref14 === void 0 ? void 0 : ref14.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.required"
                                                        }) : "")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            tablet: 6,
                                            mobile: 12,
                                            laptop: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                                        id: "category-label",
                                                        error: (ref51 = errors.category && touchedFields.category) !== null && ref51 !== void 0 ? ref51 : false,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "contact_us.category"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        labelId: "category-label",
                                                        id: "contact-us-category",
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "contact_us.category"
                                                        }),
                                                        value: getValues("category")
                                                    }, register("category")), {
                                                        error: Boolean(errors.category) && touchedFields.category,
                                                        onChange: function(e) {
                                                            setValue("category", e.target.value);
                                                            resetField("subcategory");
                                                            trigger();
                                                        },
                                                        MenuProps: {
                                                            BackdropProps: {
                                                                sx: {
                                                                    backgroundColor: "transparent",
                                                                    backdropFilter: "none"
                                                                }
                                                            }
                                                        },
                                                        displayEmpty: true,
                                                        renderValue: function() {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                component: "span",
                                                                children: getValues("category") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "contact_us.".concat(contact_us/* categoryList.find */.wA.find(function(category) {
                                                                        return category === getValues("category");
                                                                    }))
                                                                }) : ""
                                                            });
                                                        },
                                                        children: contact_us/* categoryList.map */.wA.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                value: item,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                                        checked: item === getValues("category")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "contact_us.".concat(item)
                                                                    })
                                                                ]
                                                            }, index);
                                                        })
                                                    })),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                        error: true,
                                                        children: touchedFields.category && ((errors === null || errors === void 0 ? void 0 : (ref15 = errors.category) === null || ref15 === void 0 ? void 0 : ref15.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.required"
                                                        }) : "")
                                                    })
                                                ]
                                            })
                                        }),
                                        (getValues("category") === contact_us/* COMPLAINT */.Kb || getValues("category") === contact_us/* ONLINE_BOOKING */.ac) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    tablet: 6,
                                                    mobile: 12,
                                                    laptop: 6,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                                                id: "subcategory-label",
                                                                error: (ref52 = errors.subcategory && touchedFields.subcategory) !== null && ref52 !== void 0 ? ref52 : false,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "contact_us.subcategory"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                labelId: "subcategory-label",
                                                                id: "contact-us-subcategory",
                                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "contact_us.subcategory"
                                                                }),
                                                                value: getValues("subcategory")
                                                            }, register("subcategory")), {
                                                                error: Boolean(errors.subcategory) && touchedFields.subcategory,
                                                                onChange: function(e) {
                                                                    setValue("subcategory", e.target.value);
                                                                    trigger();
                                                                },
                                                                MenuProps: {
                                                                    BackdropProps: {
                                                                        sx: {
                                                                            backgroundColor: "transparent",
                                                                            backdropFilter: "none"
                                                                        }
                                                                    }
                                                                },
                                                                displayEmpty: true,
                                                                renderValue: function() {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        component: "span",
                                                                        children: getValues("subcategory") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                            id: "contact_us.".concat(subCategories.find(function(subcategory) {
                                                                                return subcategory === getValues("subcategory");
                                                                            }))
                                                                        }) : ""
                                                                    });
                                                                },
                                                                children: subCategories.map(function(item, index) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                        value: item,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                                                checked: item === getValues("subcategory")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                                id: "contact_us.".concat(item)
                                                                            })
                                                                        ]
                                                                    }, index);
                                                                })
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                                error: true,
                                                                children: touchedFields.subcategory && ((errors === null || errors === void 0 ? void 0 : (ref16 = errors.subcategory) === null || ref16 === void 0 ? void 0 : ref16.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "global.required"
                                                                }) : "")
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    tablet: 6,
                                                    mobile: 12,
                                                    laptop: 6,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                id: "contact-us-subject",
                                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "contact_us.subject"
                                                                    })
                                                                }),
                                                                variant: "outlined"
                                                            }, register("subject")), {
                                                                error: (ref53 = errors.subject && touchedFields.subject) !== null && ref53 !== void 0 ? ref53 : false,
                                                                InputProps: {
                                                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                                        errorCondition: errors.subject && touchedFields.subject
                                                                    })
                                                                }
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                                error: true,
                                                                children: touchedFields.subject && ((errors === null || errors === void 0 ? void 0 : (ref17 = errors.subject) === null || ref17 === void 0 ? void 0 : ref17.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "global.required"
                                                                }) : (errors === null || errors === void 0 ? void 0 : (ref18 = errors.subject) === null || ref18 === void 0 ? void 0 : ref18.type) === "min" || (errors === null || errors === void 0 ? void 0 : (ref19 = errors.subject) === null || ref19 === void 0 ? void 0 : ref19.type) === "max" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                            id: "global.please.enter.valid"
                                                                        }),
                                                                        "\xa0",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                            id: "global.min.two.max.fifty"
                                                                        })
                                                                    ]
                                                                }) : (errors === null || errors === void 0 ? void 0 : (ref20 = errors.subject) === null || ref20 === void 0 ? void 0 : ref20.type) === "matches" && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "global.only.chars.allowed"
                                                                }))
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    tablet: 6,
                                                    mobile: 12,
                                                    laptop: 6,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                id: "contact-us-description",
                                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "contact_us.description"
                                                                    })
                                                                }),
                                                                variant: "outlined"
                                                            }, register("description")), {
                                                                error: (ref54 = errors.description && touchedFields.description) !== null && ref54 !== void 0 ? ref54 : false,
                                                                InputProps: {
                                                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                                        errorCondition: errors.description && touchedFields.description
                                                                    })
                                                                },
                                                                multiline: true,
                                                                rows: 3,
                                                                maxRows: 3
                                                            })),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                                error: true,
                                                                children: touchedFields.description && ((errors === null || errors === void 0 ? void 0 : (ref21 = errors.description) === null || ref21 === void 0 ? void 0 : ref21.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "global.required"
                                                                }) : (errors === null || errors === void 0 ? void 0 : (ref22 = errors.description) === null || ref22 === void 0 ? void 0 : ref22.type) === "min" || (errors === null || errors === void 0 ? void 0 : (ref23 = errors.description) === null || ref23 === void 0 ? void 0 : ref23.type) === "max" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                            id: "global.please.enter.valid"
                                                                        }),
                                                                        "\xa0",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                            id: "global.min.two.max.200"
                                                                        })
                                                                    ]
                                                                }) : (errors === null || errors === void 0 ? void 0 : (ref24 = errors.description) === null || ref24 === void 0 ? void 0 : ref24.type) === "matches" && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "global.only.chars.allowed"
                                                                }))
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        getValues("category") !== contact_us/* COMPLAINT */.Kb && getValues("category") !== contact_us/* ONLINE_BOOKING */.ac && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            item: true,
                                            tablet: 6,
                                            mobile: 12,
                                            laptop: 6,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            id: "contact-us-subject"
                                                        }, register("subject")), {
                                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "contact_us.subject"
                                                                })
                                                            }),
                                                            variant: "outlined"
                                                        }), register("subject")), {
                                                            error: (ref55 = errors.subject && touchedFields.subject) !== null && ref55 !== void 0 ? ref55 : false,
                                                            InputProps: {
                                                                endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                                    errorCondition: errors.subject && touchedFields.subject
                                                                })
                                                            }
                                                        })),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                            error: true,
                                                            children: touchedFields.subject && ((errors === null || errors === void 0 ? void 0 : (ref25 = errors.subject) === null || ref25 === void 0 ? void 0 : ref25.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "global.required"
                                                            }) : (errors === null || errors === void 0 ? void 0 : (ref26 = errors.subject) === null || ref26 === void 0 ? void 0 : ref26.type) === "min" || (errors === null || errors === void 0 ? void 0 : (ref27 = errors.subject) === null || ref27 === void 0 ? void 0 : ref27.type) === "max" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "global.please.enter.valid"
                                                                    }),
                                                                    "\xa0",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "global.min.two.max.fifty"
                                                                    })
                                                                ]
                                                            }) : (errors === null || errors === void 0 ? void 0 : (ref28 = errors.subject) === null || ref28 === void 0 ? void 0 : ref28.type) === "matches" && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "global.only.chars.allowed"
                                                            }))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                                    sx: {
                                                        pt: {
                                                            tablet: "16px",
                                                            mobile: "16px"
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            id: "contact-us-description",
                                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "contact_us.description"
                                                                })
                                                            }),
                                                            variant: "outlined"
                                                        }, register("description")), {
                                                            error: (ref56 = errors.description && touchedFields.description) !== null && ref56 !== void 0 ? ref56 : false,
                                                            InputProps: {
                                                                endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                                    errorCondition: errors.description && touchedFields.description
                                                                })
                                                            },
                                                            multiline: true,
                                                            rows: 3,
                                                            maxRows: 3
                                                        })),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                            error: true,
                                                            children: touchedFields.description && ((errors === null || errors === void 0 ? void 0 : (ref29 = errors.description) === null || ref29 === void 0 ? void 0 : ref29.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "global.required"
                                                            }) : (errors === null || errors === void 0 ? void 0 : (ref30 = errors.description) === null || ref30 === void 0 ? void 0 : ref30.type) === "min" || (errors === null || errors === void 0 ? void 0 : (ref31 = errors.description) === null || ref31 === void 0 ? void 0 : ref31.type) === "max" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "global.please.enter.valid"
                                                                    }),
                                                                    "\xa0",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "global.min.two.max.200"
                                                                    })
                                                                ]
                                                            }) : (errors === null || errors === void 0 ? void 0 : (ref32 = errors.description) === null || ref32 === void 0 ? void 0 : ref32.type) === "matches" && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "global.only.chars.allowed"
                                                            }))
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            tablet: 6,
                                            mobile: 12,
                                            laptop: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileUploadComponent, {
                                                accept: {
                                                    "image/png": [
                                                        ".png"
                                                    ],
                                                    "image/jpeg": [
                                                        ".jpeg",
                                                        ".jpg"
                                                    ],
                                                    "application/pdf": [
                                                        ".pdf"
                                                    ]
                                                },
                                                imgType: true,
                                                handleFiles: handleUploadFile,
                                                initValues: fileInitialValue || submittedImage,
                                                isLoading: uploadFile.isLoading,
                                                errorFile: errorFile
                                            })
                                        }),
                                        !(user === null || user === void 0 ? void 0 : user.phoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            tablet: 12,
                                            mobile: 12,
                                            laptop: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    "&.MuiFormControl-root  div > div > div ": {
                                                        mx: "auto"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                                    ref: recaptchaRef,
                                                    sitekey: publicRuntimeConfig.recaptchaClientKey,
                                                    onChange: onChangeCaptcha,
                                                    hl: locale
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            tablet: 12,
                                            mobile: 12,
                                            laptop: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    "& button": {}
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                                    variant: "contained",
                                                    loading: createContactUs.isLoading,
                                                    sx: {
                                                        width: {
                                                            tablet: (0,typography/* pxToRem */.Q)(178),
                                                            mobile: "145px"
                                                        },
                                                        height: {
                                                            tablet: (0,typography/* pxToRem */.Q)(56),
                                                            mobile: "56px"
                                                        },
                                                        borderRadius: "16px"
                                                    },
                                                    onClick: function() {
                                                        return onSubmit();
                                                    },
                                                    disabled: !isValid || !Boolean(recaptchaValue) && !Boolean(user === null || user === void 0 ? void 0 : user.phoneNumber) && !user,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        component: "p",
                                                        sx: {
                                                            fontSize: (0,typography/* pxToRem */.Q)(16),
                                                            fontWeight: "700",
                                                            lineHeight: "24px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "global.submit"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages_contact_us = (ContactUs);


/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6886,2482,9781,9099,4465,7801,4879,2895,8024,9774,2888,179], function() { return __webpack_exec__(87794); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);